<div class="app-search-container" role="search">
  <mat-form-field class="app-input-form-field">
    <button
      class="aca-search-input--search-button"
      mat-icon-button
      matPrefix
      (click)="executeSearch()"
      [title]="'SEARCH.BUTTON.TOOLTIP' | translate"
    >
      <mat-icon [attr.aria-label]="'SEARCH.BUTTON.ARIA-LABEL' | translate">search</mat-icon>
    </button>

    <input
      matInput
      #searchInputField
      class="app-search-input"
      [attr.aria-label]="'SEARCH.INPUT.ARIA-LABEL' | translate"
      type="text"
      [(ngModel)]="searchedWord"
      (keydown.enter)="onSearchSubmit($event)"
      [placeholder]="'SEARCH.INPUT.PLACEHOLDER' | translate"
      autocomplete="off"
    />

    <div matSuffix class="aca-search-input--suffix">
      <mat-button-toggle-group class="aca-search-input--suffix-button-toggle-group" [attr.aria-label]="'SEARCH.INPUT.SEARCH_MODE_TOGGLE_DESCRIPTION' | translate" [attr.title]="'SEARCH.INPUT.SEARCH_MODE_TOGGLE_DESCRIPTION' | translate" [(ngModel)]="queryBuilder.searchMode">
        <mat-button-toggle value="regular" [attr.aria-label]="'SEARCH.INPUT.SEARCH_MODE_TOGGLE_DESCRIPTION_REGULAR' | translate">
          <mat-icon>title</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle value="formula" [attr.aria-label]="'SEARCH.INPUT.SEARCH_MODE_TOGGLE_DESCRIPTION_FORMULA' | translate">
          <mat-icon>extension</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>

      <aca-search-in-menu (filtersApplied)="onFiltersApplied()" />

      <button
        class="aca-search-input--close-button"
        mat-icon-button
        [attr.aria-label]="'SEARCH.CLOSE_BUTTON.ARIA_LABEL' | translate"
        [attr.title]="'SEARCH.CLOSE_BUTTON.ARIA_LABEL' | translate"
        (click)="exitSearch()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-form-field>

  @if (error) {
    <mat-error class="app-search-error" role="alert" aria-live="assertive">
      {{ error | translate }}
    </mat-error>
  }
</div>
